// extracted by mini-css-extract-plugin
module.exports = {"container":"LimitedAccess_container__1bl2W","teaser":"LimitedAccess_teaser__VDNQH"};